import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { AuthShell } from "./AuthPages";
import { useI18n } from "./i18n";
import { CL } from "./api";
import { formatApiError } from "./auth";

export default function VerifyEmail() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading", msg: "" });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    CL.verifyEmail(params.get("token") || "")
      .then(() => setState({ status: "ok", msg: "" }))
      .catch((e) => setState({ status: "error", msg: formatApiError(e.response?.data?.detail) }));
  }, [params]);

  return (
    <AuthShell title={t("verifyTitle")} subtitle=""
      footer={<a href="/" className="font-medium text-[#14512f] hover:underline" data-testid="verify-continue">{t("verifyContinue")}</a>}>
      {state.status === "loading" && <p className="text-sm text-[#6b7268]">…</p>}
      {state.status === "ok" && (
        <div className="flex items-center gap-2 text-[#14512f]" data-testid="verify-success"><CheckCircle2 className="h-5 w-5" />{t("verifyOk")}</div>
      )}
      {state.status === "error" && (
        <div className="flex items-center gap-2 text-red-700" data-testid="verify-error"><XCircle className="h-5 w-5" />{state.msg || t("verifyFail")}</div>
      )}
    </AuthShell>
  );
}
